/*
$.bounds
jquery helper for getBoundingClientRect
2015-04-05 pascal
*/
(function($){
    'use strict'

    var $window = $(window)

    $.fn.bounds = function() {
        var bounds,
            el = this.get(0)

        if (el && el.getBoundingClientRect) {
            var rect = el.getBoundingClientRect(),
                scrolltop = $window.scrollTop()

            // getBoundingClientRect returns a read-only object, so we clone it
            // $.clone chokes on this object for some reason, so doing an object literal copy

            // rect.top and rect.bottom are relative to the viewport
            // we almost always want to know the position relative to the top of the document
            // so we add the scroll top amount
            bounds = {
                top: rect.top + scrolltop,
                bottom: rect.bottom + scrolltop,
                left: rect.left,
                right: rect.right,
                height: rect.height,
                width: rect.width,
            }
        }
        return bounds
    }
})(jQuery)
